export const webOrReviewAppMarker = 'web-or-review-app';
